import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Button, Divider, Fade, FormControlLabel, Checkbox, IconButton, Backdrop, CircularProgress } from '@mui/material';
import loginbg from '../assets/images/new-background.png';
import NewLogo from '../assets/images/Layer_1.png';
import { Email, Lock } from '@mui/icons-material';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { useNavigate, Link } from 'react-router-dom';
import CustomInputBox from '../components/customInputBox/CustomInputBox';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingButton from '@mui/lab/LoadingButton';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { useDispatch, useSelector } from 'react-redux';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import packageJson from '../../package.json';
import { getCognitoUserSessions } from '../graphql/';
import axios from 'axios';
import { loginCognitoUser, logoutCognitoUser } from '../graphql/';
import { logIn } from '../redux/reducers/login';
import { Modal } from '../components/modals/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { useDebounce } from '../hooks/useDebounce';
import { closeSnackbar, showErrorSnackbar, showWarningSnackbar } from '../components/snackBar/snakbar';
import { persistor } from '../redux/store';
import API_ENDPOINTS from '../apiEndpoints';
import { CLIENT_ID } from '../config.js';

const themess = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#75428C',
    },
    danger: {
      main: '#e55353',
    },
  },
});
const Login = () => {
  // if (document.getElementsByClassName('Class-poper').length !== 0 || document.getElementsByClassName('custom-popover-class').length !== 0) {
  //   window.location.reload();
  // }
  const dispatch = useDispatch();

  let navigate = useNavigate();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    email: '',
    Password: '',
    open: false,
    errorStatus: {
      email: false,
      Password: false,
    },
    errorFields: {
      email: '',
      Password: '',
      open: '',
    },
  });
  const [showPassword, setShowPassword] = useState(false);
  const [BackDrop, setBackDrop] = useState(false);

  useEffect(() => {
    createScript();
    closeSnackbar()
  }, []);
  const checkAccountVerified = async (email) => {
    try {
      // [isUserConfirmed, isUserExist]
      let response = await axios.post(API_ENDPOINTS.REACT_APP_SIGNUP_CHECK, {
        email,
      });
      if (response.data.error === 'You Have Already Registered With Google Account. Use Google Sign In') {
        showWarningSnackbar('You Have Already Registered With Google Account. Use Google Sign In');
        return [true, false, true];
      }
      if (response.data.error === 'User Does not exist !') {
        return [false, false];
      }
      if (response.data.userStatus === 'UNCONFIRMED') {
        return [true, true];
      } else {
        return [true, false];
      }
    } catch (error) {
      console.log(error);
      return [false, false];
    }
  };
  const handleForgetPasswordClick = async () => {
    if (state?.email) {
      setBackDrop(true);
      const [userExist, accountnotverified, googleuser] = await checkAccountVerified(state.email);
      if (googleuser) {
        return setBackDrop(false);
      }
      if (!userExist) {
        setBackDrop(false);
        return showWarningSnackbar('User does not exist');
      }
      if (accountnotverified) {
        await Auth.resendSignUp(state?.email);
        return navigate('/confirmsignup', { state: { email: state.email, status: 'unverified' } });
      }
      await Auth.forgotPassword(state.email)
        .then((data) => {
          localStorage.setItem('startTime', new Date());
          navigate('/newPassword', { state: { email: state.email } });
          setState((prev) => ({
            ...prev,
            open: false,
            errorFields: {
              ...prev.errorFields,
              open: '',
            },
          }));
        })
        .catch((error) => {
          if (error.name === 'LimitExceededException') {
            setState((prev) => ({
              ...prev,
              errorStatus: { ...prev.errorStatus, email: true },
              errorFields: { ...prev.errorFields, email: error.message },
            }));
          } else if (error.code == 'UserNotFoundException') {
            axios
              .post(API_ENDPOINTS.REACT_APP_SIGNUP_CHECK, {
                email: state.email,
              })
              .then((response) => {
                if (response.request.status === 201) {
                  showWarningSnackbar(response.data.error);
                } else if (response.request.status === 200) {
                  showWarningSnackbar(response.data.error);
                }
                setLoading(false);
              })
              .catch((err) => {
                showWarningSnackbar('Network Error !');
              });
          } else {
            setState((prev) => ({
              ...prev,
              errorStatus: { ...prev.errorStatus, email: true },
              errorFields: {
                ...prev.errorFields,
                email: "Email doesn't exist. if you signed up using Google please login with Google button",
              },
            }));
          }
          // showWarningSnackbar("The user either did not sign up with us or used a Google account to sign up")
          // navigate("/forgotPassword")
        })
        .finally(() => {
          setBackDrop(false);
        });
    } else {
      setState((prev) => ({
        ...prev,
        errorStatus: { ...prev.errorStatus, Password: false, email: true },
        errorFields: {
          ...prev.errorFields,
          Password: '',
          email: 'Please enter an email',
        },
      }));

      // navigate("/forgotPassword")
    }
  };
  // Load the Google client
  const createScript = () => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = initGsi;
    document.body.appendChild(script);
  };
  const [reminder, setReminder] = useState(false);

  const handleEditError = (name, value) => {
    if (value == '') {
      setState((prev) => ({
        ...prev,
        [name]: value,
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: 'Email is Required',
        },
      }));
    } else if (
      !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value)
    ) {
      setState((prev) => ({
        ...prev,
        [name]: value,
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: 'Invalid Email Address',
        },
      }));
    }
  };
  const debouncedSearch = useCallback(
    useDebounce(
      (name, value) => {
        handleEditError(name, value);
      },
      500,
      false
    ),
    []
  );
  const [submit, setSubmit] = useState(false);
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const handleFormSubmission = (event) => {
    setSubmit(true);

    event.preventDefault();

    const { email, Password } = state;

    const formData = {
      email: email,
      Password: Password,
    };

    if (formValidation(formData)) {
      setBackDrop(true);
      setLoading(true);
      signIn(formData);
    }
  };
  useEffect(() => {
    window.onload = function () {
      var rememberedUsername = localStorage.getItem('rememberedUsername');

      if (rememberedUsername) {
        document.getElementById('email').value = rememberedUsername;
        document.getElementById('checkbox').checked = true;
      }
    };
  }, []);

  const [logoutFromAllDevice, setlogoutFromAllDevice] = useState(false);

  const ForceLogoutAndLogin = async () => {
    try {
      setBackDrop(true);
      setLoading(true);
      let accessToken = logoutFromAllDevice;

      if (accessToken) {
        const option = {
          method: 'POST',
          url: API_ENDPOINTS.REACT_APP_GLOBAL_SIGNOUT_URL,
          headers: { Authorization: accessToken },
        };
        const response = await axios(option);
      }

      let sessions = await API.graphql(graphqlOperation(logoutCognitoUser));
      const { email, Password } = state;

      let response = await Auth.signIn(email, Password);
      setState((prev) => ({
        ...prev,
        open: false,
        errorFields: {
          ...prev.errorFields,
          open: '',
        },
      }));

      const devicekey = Date.now()?.toString();

      localStorage.setItem('deviceKey', devicekey);
      let createSession = await API.graphql(graphqlOperation(loginCognitoUser, { LinkedSessionID: devicekey }));

      localStorage.setItem('sessionID', createSession.data.loginCognitoUser.sessionid);
      dispatch(logIn());
      navigate('/');
    } catch (error) {
    } finally {
      setLoading(false);
      setBackDrop(false);
      setlogoutFromAllDevice(false);
    }
  };

  async function signIn(values) {
    try {
      let response = await Auth.signIn(values.email, values.Password);
      setState((prev) => ({
        ...prev,
        open: false,
        errorFields: {
          ...prev.errorFields,
          open: '',
        },
      }));
      setLoading(false);
      setBackDrop(false);

      let sessions = await API.graphql(graphqlOperation(getCognitoUserSessions));
      let now = Date.now() / 1000;
      let session = sessions?.data?.getCognitoUserSessions?.filter((session) => {
        console.log(now, session.logintimestamp, session.logintimestamp - now);
        return session.logintimestamp - now > -360;
      });
      const devicekey = Date.now()?.toString();

      localStorage.setItem('deviceKey', devicekey);
      if (session.length) {
        let accessToken = null;
        Object.keys(response?.storage).map((key) => {
          if (key.startsWith('CognitoIdentityServiceProvider') && key.endsWith('.accessToken')) {
            accessToken = response.storage[key];
          }
        });
        if (accessToken) setlogoutFromAllDevice(accessToken);
      } else {
        let createSession = await API.graphql(
          graphqlOperation(loginCognitoUser, {
            LinkedSessionID: devicekey,
          })
        );
        localStorage.setItem('sessionID', createSession.data.loginCognitoUser.sessionid);
        dispatch(logIn());
        navigate('/');
      }
      localStorage.setItem('Remembered', reminder);
      if (!reminder) {
        const createSessionCookie = () => {
          document.cookie = 'rememberMe=false; path=/; secure; samesite=strict';
        };
        createSessionCookie();
      }
    } catch (error) {
      console.log(error);

      if (error.code == 'UserNotConfirmedException') {
        setState((prev) => ({
          ...prev,
          // open: true,
          errorFields: {
            ...prev.errorFields,
            open: error.message,
          },
        }));
        if (error?.message?.length) {
          showErrorSnackbar(error.message);
        } else {
          showErrorSnackbar('Network Error');
        }

        try {
          await Auth.resendSignUp(values.email);
          navigate('/confirmsignup', {
            state: { email: values.email, password: values.Password },
          });
        } catch (error) {
          showErrorSnackbar('Too many Attempts! Please try again later');
        }
        setLoading(false);
        setBackDrop(false);
      } else if (error.code == 'UserNotFoundException') {
        axios
          .post(API_ENDPOINTS.REACT_APP_SIGNUP_CHECK, { email: values.email })
          .then((response) => {
            if (response.request.status === 201) {
              showWarningSnackbar(response.data.error);
            } else if (response.request.status === 200) {
              showWarningSnackbar(response.data.error);
            }
            setLoading(false);
            setBackDrop(false);
          })
          .catch((errors) => {
            console.log(errors);
            setLoading(false);
            setBackDrop(false);
          });
      } else if (error.code == 'NotAuthorizedException') {
        showErrorSnackbar(error.message);
        setLoading(false);
        setBackDrop(false);
      } else {
        showErrorSnackbar('Network Error');
        setState((prev) => ({
          ...prev,
          open: true,
          errorFields: {
            ...prev.errorFields,
            open: error.message,
          },
        }));
        setBackDrop(false);
        setLoading(false);
      }
    } finally {
      setLoading(false);
      setBackDrop(false);
    }
  }

  // Initialize Google client and render Google button
  const initGsi = () => {
    if (window.google && window.google?.accounts) {
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: async (response) => {
          try {
            setBackDrop(true);

            const option = {
              method: 'POST',
              url: API_ENDPOINTS.REACT_APP_SIGNUP_CHECK2,
              data: JSON.stringify({ credential: response.credential }),
            };
            const responseA = await axios(option);

            if (responseA.status === 200 || responseA.status === 201) {
              await Auth.federatedSignIn({
                provider: CognitoHostedUIIdentityProvider.Google,
              });
            } else {
              showWarningSnackbar(responseA.data.error);
            }
          } catch (e) {
            console.log('error', e);
          } finally {
            setBackDrop(false);
          }
        },
      });

      const container = document.getElementById('credentialBox');
      const target = document.getElementById('googleSignInButton');

      if (container && target) {
        const width = container.offsetWidth;
        target.innerHTML = '';
        window.google.accounts.id.renderButton(target, {
          theme: 'outline',
          size: 'large',
          width: width,
        });
      }
    }
  };

  const formValidation = (data) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    let isvalid = true;
    Object.keys(data).map((itemKey) => {
      if (itemKey === 'email') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Email is Required',
            },
          }));
        } else if (!regex.test(data[itemKey])) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Invalid email address',
            },
          }));
        } else {
          isvalid = true;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }

      if (itemKey === 'Password') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Password is Required',
            },
          }));
        } else if (data[itemKey].trim().length > 0 && data[itemKey].trim().length < 4) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Please enter atleast 4 digits',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }
    });

    return isvalid;
  };
  const { loginStatus } = useSelector((state) => state.loginActions);

  return (
    <>
      <Backdrop open={BackDrop} sx={{ zIndex: 999 }}>
        <CircularProgress />
      </Backdrop>
      <Fade in={true}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
            alignItems: {
              xs: 'center',
              md: 'normal',
            },
            justifyContent: {
              xs: 'center',
              md: 'normal',
            },

            background: '#e7e7e7',
            backgroundImage: `url(${loginbg})`,
            backgroundPosition: 'left',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'auto 100%',
            width: '100%',
            minHeight: '100vh',
            padding: {
              xs: '8px 8px',
              sm: '0px 40px',
              md: '0px 0px',
            },
            height: '100%',
            boxSizing: 'border-box',
          }}
        >
          {!matches ? (
            <Box
              sx={{
                width: '43%',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingLeft: '60px',
                paddingRight: '60px',
              }}
            >
              <Box
                sx={{
                  // height: "70%",
                  width: '80%',
                  position: 'relative',
                  top: '45%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box sx={{ width: '100%' }}>
                  <Box
                    component={'div'}
                    sx={{
                      width: '45%',
                      height: '45%',
                      backgroundImage: `url(${NewLogo})`,
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      // margin: "5% 10%"
                      marginBottom: '10px',
                    }}
                  />

                  <Box
                    sx={{
                      height: {
                        md: '290px',
                        lg: '270px',
                      },
                      width: '100%',
                    }}
                  >
                    <Box
                      sx={{
                        width: '85%',
                      }}
                    >
                      <Typography sx={{ fontSize: '32px', fontWeight: 'bolder' }}>A Little About Us!</Typography>
                      <br />
                      <Typography>
                        LedgerX is an accounting software specially designed to solve the daily business needs of a well established
                        organization. You can review your daily entries and store bills in the cloud. We constantly strive to improve our
                        product and welcome your feedback at&nbsp;
                        <a href="mailto:support@ledgerx.biz" style={{ textDecoration: 'none' }}>
                          &nbsp;support@ledgerx.biz
                        </a>
                        .
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                width: {
                  xs: '90%',
                  sm: '80%',
                  md: '45%',
                  lg: '45%',
                },
                marginBottom: {
                  xs: '30px',
                  sm: '60px',
                  md: '0px',
                },
              }}
            >
              <Box
                sx={{
                  // height: { sm: "415px", xs: "310px" },
                  minHeight: '130px',
                  width: '100%',
                  backgroundImage: `url(${NewLogo})`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  // margin: "0 17%",
                }}
              />
              <Typography
                variant="h4"
                sx={{
                  marginTop: '10px',
                  color: '#3A3A3A',
                  marginBottom: '15px',
                  textAlign: {
                    xs: 'justify',
                    md: 'left',
                  },
                  fontWeight: 700,
                  fontFamily: 'sans-serif',
                }}
              >
                A Little About Us!
              </Typography>

              <Typography
                sx={{
                  color: '#3A3A3A',
                  marginBottom: '15px',
                  textAlign: {
                    xs: 'justify',
                    md: 'left',
                  },
                  fontFamily: 'sans-serif',
                }}
              >
                LedgerX is an accounting software specially designed to solve the daily business needs of an well established organization,
                You can review your daily entries and store bills in the cloud.
              </Typography>
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: {
                xs: '100%',
                sm: '80%',
                md: '45%',
                lg: '45%',
              },
              paddingLeft: {
                xs: '0px',
                md: '30px',
              },
              paddingRight: {
                xs: '0px',
                md: '30px',
              },
            }}
          >
            <Box
              component={'form'}
              onSubmit={(event) => handleFormSubmission(event)}
              sx={{
                width: { xs: '100%', sm: '80%', lg: '60%' },
                height: '100%',
                top: { sm: '50%', md: '0' },
                position: 'relative',
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (e.target.id == 'googleSignInButton') {
                    e.preventDefault(); // Prevent default action for the hotkey
                  }
                  if (
                    e.target.id !== 'signUp' &&
                    e.target.id !== 'checkbox' &&
                    e.target.id !== 'googleSignInButton' &&
                    e.target.id !== 'FrPasswrd'
                  ) {
                    handleFormSubmission(e);
                  }
                }
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  left: { md: '55%', sm: '0' },
                  top: '50%',
                  transform: { md: 'translate(-50%,-50%)', sm: '' },
                  width: { sm: '80%', md: '90%' },
                  flexShrink: 0,
                  backgroundColor: 'transparent',
                  padding: { sm: '40px', xs: 0 },
                  paddingBottom: '10px',
                  borderRadius: '5px',
                }}
              >
                <Box>
                  <div
                    class="image"
                    style={{
                      width: '100%',
                      flexShrink: '0',
                      marginBottom: '20px',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { md: '25px', lg: '30px', sm: '25px' },
                        fontWeight: 'bolder',
                        color: '#75428C',
                      }}
                    >
                      Welcome Back!
                    </Typography>
                  </div>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    display: 'block',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                  }}
                >
                  <Box
                    sx={{
                      mt: '35px',
                      width: '100%',
                      textAlign: 'center',
                      height: '10%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <div type="button" id="googleSignInButton" />
                  </Box>
                  <Box
                    sx={{
                      marginBottom: '5px',
                      marginTop: '5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Box sx={{ width: '90%' }}>
                      <ThemeProvider theme={themess}>
                        <Divider textAlign="center">
                          <Typography
                            sx={{
                              color: '#9F9F9F',
                            }}
                          >
                            or
                          </Typography>
                        </Divider>
                      </ThemeProvider>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    id="credentialBox"
                    sx={{
                      width: '90%',
                      mt: '5px',
                    }}
                  >
                    <CustomInputBox
                      component="input"
                      name="email"
                      from={'Login'}
                      label={'Email'}
                      placeholder="Enter Your Email"
                      type="email"
                      autoFocus={true}
                      autoComplete="on"
                      onBlur={(e) => {
                        const { name, value } = e.target;
                        if (value !== '') handleEditError(name, value);
                      }}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        if (submit) {
                          debouncedSearch(name, value);
                        }

                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      }}
                      state={state}
                      icon={
                        <Email
                          sx={{
                            color: state.errorStatus.email === true ? 'danger.main' : '#8a8787',
                          }}
                          className="icon"
                        />
                      }
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      width: '90%',
                    }}
                  >
                    <CustomInputBox
                      from={'Login'}
                      name="Password"
                      label="Password"
                      type={showPassword ? 'text' : 'Password'}
                      autoFocus={false}
                      autoComplete="on"
                      onChange={(e) => {
                        const { name, value } = e.target;
                        if (value == '') {
                          setState((prev) => ({
                            ...prev,
                            [name]: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              [name]: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              [name]: 'Password is Required',
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            [name]: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              [name]: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              [name]: '',
                            },
                          }));
                        }
                      }}
                      state={state}
                      icon={
                        <Lock
                          sx={{
                            color: state.errorStatus.Password === true ? 'danger.main' : '#8a8787',
                          }}
                          className="icon"
                        />
                      }
                      Icon={
                        <span
                          onClick={() => {
                            if (!showPassword) {
                              setShowPassword(true);
                            } else {
                              setShowPassword(false);
                            }
                          }}
                        >
                          {showPassword ? (
                            <VisibilityOffIcon
                              sx={{
                                color: state.errorStatus.Password === true ? 'danger.main' : '#8a8787',
                              }}
                              className="iconPassword"
                            />
                          ) : (
                            <VisibilityIcon
                              sx={{
                                color: state.errorStatus.Password === true ? 'danger.main' : '#8a8787',
                              }}
                              className="iconPassword"
                            />
                          )}
                        </span>
                      }
                    />
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '10px',
                      width: '90%',
                    }}
                  >
                    {/* <FormControlLabel
                      sx={{ color: "#75428C" }}
                      control={
                        <Checkbox
                          id="checkbox"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setReminder(!reminder);
                            }
                          }}
                          checked={reminder}
                          onChange={(e) => {
                            setReminder(e.target.checked);
                          }}
                          sx={{ fontSize: "15px", color: "#75428C" }}
                        />
                      }
                      label="Remember me"
                    /> */}
                    <Link
                      id="FrPasswrd"
                      style={{
                        fontSize: '15px',
                        textDecoration: 'none',
                        fontWeight: '600',
                        color: '#3A3A3A',
                        marginBottom: '0',
                        cursor: 'pointer',
                      }}
                      onClick={handleForgetPasswordClick}
                    >
                      Forgot Password ?
                    </Link>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '10px',
                      width: '90%',
                    }}
                  >
                    <LoadingButton
                      style={{
                        width: '100%',
                        height: '40px',
                        background: '#75428C',
                        borderRadius: '5px',
                      }}
                      loading={loading}
                      disableRipple={true}
                      variant="contained"
                      onClick={(event) => {
                        handleFormSubmission(event);
                      }}
                    >
                      {/* Sign In */}
                      Log In
                    </LoadingButton>
                  </Box>
                </Box>

                <Box
                  sx={{
                    textAlign: 'center',
                    height: '10%',
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '10px',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                  }}
                >
                  <Box
                    sx={{
                      width: '314px',
                      height: '40px',
                      flexShrink: 0,
                    }}
                  >
                    <Box sx={{display:"flex",justifyContent:"center",alignItems:"center",gap:"5px"}}>
                      {/* Don't have an account with us?{""} */}<Typography>Don't have an account?</Typography> <Link
                        id="signUp"
                        style={{
                          color: '#0202ffea',
                        }}
                        to="/Create_Account"
                      >
                        <p>
                          <b>Sign up</b><ArrowOutwardIcon sx={{fontSize : "14px"}}/>
                        </p>
                      </Link>
                      {/* {<b style={{ color: "#75428C", }}>Sign Up</b>} */}
                      
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    textAlign: 'center',

                    mt: '65px',
                    mb: '15px',
                  }}
                >
                  <Typography color={'grey'}>Version {packageJson.version}</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Fade>
      <Modal open={logoutFromAllDevice}>
        <Modal.Header>
          <Box>
            <ThemeProvider theme={themess}>
              <Box
                sx={{
                  backgroundColor: 'primary.main',
                  padding: '5px 10px',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      color: '#fff',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    Warning
                    <IconButton aria-label="delete" onClick={() => setlogoutFromAllDevice(false)}>
                      <CloseIcon sx={{ color: '#fff' }} />
                    </IconButton>
                  </Typography>
                </Box>
              </Box>
            </ThemeProvider>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <Typography sx={{ background: '#fff', padding: '5px' }}>
            You have an active login session with another device! <br /> Do you want to log in here? (This will close all active sessions)
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Box>
            <ThemeProvider theme={themess}>
              <Box
                sx={{
                  background: '#fff',
                  display: 'flex',
                  justifyContent: 'end',
                  gap: '5px',
                  padding: '5px',
                }}
              >
                <Button
                  variant="outlined"
                  onClick={async () => {
                    setlogoutFromAllDevice(false);
                    await Auth.signOut();
                    localStorage.clear();
                    persistor.purge(); // purge redux
                  }}
                >
                  Close
                </Button>
                <LoadingButton loading={loading} variant="contained" onClick={ForceLogoutAndLogin}>
                  Log In
                </LoadingButton>
              </Box>
            </ThemeProvider>
          </Box>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Login;
